export default function News() {
  return (
    <div className="flex flex-col gap-4">
      <div className="bg-white border border-border rounded-2xl px-11 py-10 max-[680px]:px-6 max-[680px]:py-7">
        <h1 className="font-display text-[30px] font-semibold text-primary-dark mb-2.5 leading-tight">News</h1>
        <p className="text-sm text-[#555] leading-relaxed max-w-[620px]">
          Latest updates and announcements from the MA &amp; PA Program.
        </p>
      </div>

      <div className="bg-white border border-border rounded-2xl px-10 py-9 flex flex-col gap-5 text-sm text-[#444] leading-[1.7] max-[680px]:px-6">
        <p className="text-[#888]">No news articles yet. Check back soon.</p>
      </div>
    </div>
  );
}
